import { cn } from '@workspace/ui/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

const spinnerVariants = cva(
  'inline-block animate-spin shrink-0 rounded-full border-2 border-current border-t-transparent',
  {
    variants: {
      size: {
        xs: 'size-3',
        sm: 'size-3.5',
        md: 'size-4',
        lg: 'size-5',
        xl: 'size-6',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
);

type SpinnerProps = React.HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof spinnerVariants>;

const Spinner = React.forwardRef<HTMLSpanElement, SpinnerProps>(
  ({ className, size, ...props }, ref) => {
    return (
      <span
        ref={ref}
        aria-hidden="true"
        className={cn(spinnerVariants({ size, className }))}
        {...props}
      />
    );
  },
);

Spinner.displayName = 'Spinner';

export { Spinner, spinnerVariants };
